import { useQuery } from '@tanstack/react-query'

import { AstraCallout } from '~/astra'
import { dispatchDefaultToast, dispatchSuccessToast } from '~/store/slices/toasterSlice'
import { HOSPITAL_CONFIG_PRACTITIONER_INCLUDE, usePractitioner } from '~/storm'

import { dispatchFirstError } from '../../Form/formErrors'
import { FormSkeleton } from '../../Form/FormSkeleton'
import { FormPageWrapper } from '../../Form/FormWrapper'
import { useResourceNavigation } from '../../useResourceNavigation'
import { practitionerProfileQueries } from '../useImportPractitionerProfiles'
import { practitionerToFormState } from './formState'
import { OnSubmitFunction, PractitionerForm } from './PractitionerForm'
import { saveEditPractitioner } from './savePractitioner'

export const EditPractitioner = () => {
    const { entityId: practitionerId, navigateToList } = useResourceNavigation()

    const { isLoading, isSuccess } = useQuery(practitionerProfileQueries.importByPractitionerId(practitionerId ?? undefined))
    const practitioner = usePractitioner({ where: { id: practitionerId ?? -1 }, include: HOSPITAL_CONFIG_PRACTITIONER_INCLUDE })

    const handleSubmit: OnSubmitFunction = async (values, defaultValues) => {
        if (!practitioner) return
        const results = await saveEditPractitioner(values, defaultValues, practitioner)
        // promise rejections is handled by PractitionerForm
        const error = dispatchFirstError(results)
        if (error) return

        if (results.length > 0) {
            dispatchSuccessToast('Kirurgprofilen er oppdatert')
        } else {
            dispatchDefaultToast('Ingen endringer er gjort')
        }
        await navigateToList()
    }

    return (
        <FormPageWrapper backCrumb={{ title: 'Kirurger', onClick: () => void navigateToList() }}>
            {isLoading ? (
                <FormSkeleton title="Rediger kirurg" />
            ) : practitioner && isSuccess ? (
                <PractitionerForm title="Rediger kirurg" initialValues={practitionerToFormState(practitioner)} onSubmit={handleSubmit} />
            ) : (
                <AstraCallout
                    text="Fant ikke spesifisert kirurg."
                    color="critical"
                    action={{ label: 'Tilbake til liste', onClick: () => void navigateToList() }}
                />
            )}
        </FormPageWrapper>
    )
}
